import React from "react";
import PropTypes from "prop-types";

class GoogleTagManagerScript extends React.Component {

    static propTypes = {
        trackingCode: PropTypes.string,
        session: PropTypes.object
    }

    render() {
        let dataLayerScript = "dataLayer=[];";
        const session = this.props.session;
        if (session && session.user && session.user.altId && !session.IsImpersonating) {
            dataLayerScript = `dataLayer=[{userId:"${session.user.altId}"},{entityId:"${session.user.entityIds.join()}"}];`;
        }
        return (
            <script dangerouslySetInnerHTML={{
                __html:
`${dataLayerScript}
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${this.props.trackingCode}');`
            }}
            />
        );
    }
}

export default GoogleTagManagerScript;
